import React from "react";
import { EmbeddedReportPage } from "components";

// Компонент дашборд Prom
const ManagerBotPage = () => {
  return (
    <EmbeddedReportPage
      pageTitle="Статистика менеджерів по Боту"
      iframeTitle="Звіт по менеджерах"
      endpointUrl="/reports/managers-bot/embed-url"
    />
  );
};

export default ManagerBotPage;
